export default __webpack_public_path__ + "static/media/Port_Aleksander_LE.508a7f1d.jpg";